import { useEffect, useRef, useState } from "react";
import axios from "axios";
import QRCode from "qrcode";
import { Link2Off, Loader2 } from "lucide-react";
import { passQrPayload } from "@/lib/eventLib";
import { PassCard } from "@/components/events/PassCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicPass({ token }) {
  const [pass, setPass] = useState(null);
  const [err, setErr] = useState("");
  const [qr, setQr] = useState("");
  const [w, setW] = useState(0);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!wrapRef.current) { return; }
    const ro = new ResizeObserver((ents) => setW(Math.floor(ents[0].contentRect.width)));
    ro.observe(wrapRef.current);
    return () => { ro.disconnect(); };
  }, [pass, qr]);

  useEffect(() => {
    QRCode.toDataURL(passQrPayload(token), { width: 600, margin: 1 }).then(setQr).catch(() => {});
  }, [token]);

  useEffect(() => {
    axios.get(`${API}/public/pass/${token}`)
      .then((r) => setPass(r.data))
      .catch(() => setErr("Ye pass link valid nahi hai."));
  }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50"><div className="text-center"><Link2Off className="h-10 w-10 mx-auto text-slate-400" /><p className="mt-3 text-red-500 font-semibold" data-testid="pass-error">{err}</p></div></div>;
  if (!pass || !qr) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-cyan-600" /></div>;

  return (
    <div className="min-h-screen bg-slate-100 py-8 px-4 flex items-start justify-center" data-testid="public-pass">
      <div className="w-full max-w-md space-y-3">
        {pass.status !== "approved" && <p className="text-xs text-center text-amber-600 bg-amber-50 border border-amber-200 rounded-lg py-1.5" data-testid="pass-pending-badge">Aapka pass abhi approve nahi hua — approve hone par yahi link valid pass ban jayegi.</p>}
        <div ref={wrapRef} className="bg-white rounded-xl shadow-lg p-2">
          {w > 0 && <PassCard pass={pass} qr={qr} widthPx={Math.min(400, w)} />}
        </div>
      </div>
    </div>
  );
}
